import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RequestHeaders } from '../../common/header-logo/request-header.component';
import KyberConfigForm from './form/kyberconfig.form';
import KyberBillAgentForm from './form/kyberbillagent.form';
import './style/kyberconfig.style.css';
import KyberStockForm from './form/kyberstock.form';
import KyberProcAgentForm from './form/kyberproagent.form';
import ChatBotForm from './form/chatbot.form';
import { Button } from "react-bootstrap";
import { ListTabButton } from '../../common/list-tab/list-tab-button.component';
import KyberConfigHistory from './history/kyberconfig.history';
import { KyberConfigActions } from '../../../store/common/chatbot/kyberconfig/kyberconfig.reducer';

const kyberConfigTabs = [
    { id: 0, label: 'Config' },
    { id: 1, label: 'History' },
];

const KyberConfig = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [selectedIndex, setSelectedIndex] = useState(0);

    const [kyberAgentEnabled, setKyberAgentEnabled] = useState(false);

    /*
     * Get the Kyber Agent configuration stored in Redux.
     *
     * roleOptions      = available roles from tbl_Roles
     * selectedRoleIds  = currently selected Kyber roles
     * isEnabled        = Enable Kyber Agents toggle value
     */
    const {
        roleOptions,
        selectedRoleIds,
        isEnabled
    } = useSelector(state => state.kyberConfig);

    /*
     * Load the Kyber Agent configuration once when
     * the main Kyber Config page is opened.
     */
    useEffect(() => {
        dispatch(KyberConfigActions.getKyberAgentConfig());
    }, [dispatch]);

    // NEW - keep child Agent forms synchronized with master Kyber Agent toggle
    useEffect(() => {
        setKyberAgentEnabled(isEnabled);
    }, [isEnabled]);

    const handlePageClose = () => {
        history.goBack();
    };

    const FilterIndex = (tabIndex) => {
        setSelectedIndex(Number(tabIndex));
    };

    return (
        <div>
            <RequestHeaders headerTitle="kyber_config" />

            <div className="request-table data-table fit-width">
                <ListTabButton
                    listData={kyberConfigTabs}
                    selectedIndex={selectedIndex}
                    FilterIndex={FilterIndex}
                />

                {selectedIndex === 0 &&
                    <>
                        <KyberConfigForm
                            roleOptions={roleOptions}
                            selectedRoleIds={selectedRoleIds}
                            isEnabled={isEnabled}
                            onEnabledChange={setKyberAgentEnabled}
                        />

                        <ChatBotForm kyberAgentEnabled={kyberAgentEnabled} />
                        <KyberBillAgentForm kyberAgentEnabled={kyberAgentEnabled} />
                        <KyberStockForm kyberAgentEnabled={kyberAgentEnabled} />
                        <KyberProcAgentForm kyberAgentEnabled={kyberAgentEnabled} />
                    </>
                }

                {selectedIndex === 1 &&
                    <KyberConfigHistory />
                }

                <div className="add-button-container custom-add-button d-flex justify-content-end">
                    <div className="btn-tooltiptext">
                        <Button
                            variant="outline-secondary"
                            className="btn-custom-violet-hover-outline"
                            onClick={handlePageClose}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KyberConfig;